module.exports = "https://bin.bnbstatic.com/_next/static/images/DEX-5d68a524ccd63fdfa86657775ab16af7.png";